import React, { useEffect } from "react";
import axios from "axios";
import Header from "../Header";
import Footer from "../Footer";
import MandalSubadminSidebar from "./MandalSubadminSidebar";

export default function MandalSubadminLayout({
  id,
  children,
  menu1,
  ac1,
  menu2,
  ac2,
  aca2,
  menu3,
  ac3,
  aca3,
  menu4,
  ac4,
  aca4,
  menu5,
  ac5,
  aca5,
  menu6,
  ac6,
  aca6,
  menu7,
  ac7,
  aca7,
  menu8,
  ac8,
  aca8,
  menu9,
  ac9,
  aca9,
  menu10,
  ac10,
  aca10,
  menu11,
  ac11,
  aca11,
  menu12,
  ac12,
  aca12,
  menu13,
  ac13,
  aca13,
  menu14,
  ac14,
  aca14,
  menu15,
  ac15,
  aca15,
  menu16,
  ac16,
  aca16,
  menu17,
  ac17,
  aca17,
  menu18,
  ac18,
  aca18,
  menu19,
  ac19,
  aca19,
  menu20,
  ac20,
  aca20,
  role
}) {
  const apiUrl = process.env.REACT_APP_API_URL; // Get the API URL from the .env file
  const refreshToken = () => {
    const token = localStorage.getItem("token");
    const storedRefreshToken = localStorage.getItem("refreshToken");
    const isLogin = localStorage.getItem("isLogin");
    if (!storedRefreshToken || isLogin === "true") return;
    const data = JSON.stringify({
      userName: localStorage.getItem("userName"),
      refreshToken: storedRefreshToken,
    });
    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiUrl}/Login/RefreshToken`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios
      .request(config)
      .then((response) => {
        if (response?.data?.data) {
          localStorage.setItem("token", response.data.data);
        }
      })
      .catch((error) => {
        console.error("Token refresh failed:", error);
      });
  };
  useEffect(() => {
    const interval = setInterval(refreshToken, 1500000);
    refreshToken();
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Header id={id} />
      <div>
        <MandalSubadminSidebar
          M1={menu1}
          A1={ac1}
          M2={menu2}
          A2={ac2}
          AC2={aca2}
          M3={menu3}
          A3={ac3}
          AC3={aca3}
          M4={menu4}
          A4={ac4}
          AC4={aca4}
          M5={menu5}
          A5={ac5}
          AC5={aca5}
          M6={menu6}
          A6={ac6}
          AC6={aca6}
          M7={menu7}
          A7={ac7}
          AC7={aca7}
          M8={menu8}
          A8={ac8}
          AC8={aca8}
          M9={menu9}
          A9={ac9}
          AC9={aca9}
          M10={menu10}
          A10={ac10}
          AC10={aca10}
          M11={menu11}
          A11={ac11}
          AC11={aca11}
          M12={menu12}
          A12={ac12}
          AC12={aca12}
          M13={menu13}
          A13={ac13}
          AC13={aca13}
          M14={menu14}
          A14={ac14}
          AC14={aca14}
          M15={menu15}
          A15={ac15}
          AC15={aca15}
          M16={menu16}
          A16={ac16}
          AC16={aca16}
          M17={menu17}
          A17={ac17}
          AC17={aca17}
          M18={menu18}
          A18={ac18}
          AC18={aca18}
          M19={menu19}
          A19={ac19}
          AC19={aca19}
          M20={menu20}
          A20={ac20}
          AC20={aca20}
          role={role}
        />
        <div className="content-wrapper">{children}</div>
      </div>
      <Footer />
    </div>
  );
}
